var _browserCookies$COUNT;
import { COUNTRY_COOKIE_KEY, LANGUAGE_COOKIE_KEY } from '@crehana/constants';
import { LANGUAGES } from '@crehana/ts-types';
import { cookies } from '@crehana/utils';
var browserCookies = /*#__PURE__*/cookies.getAll();
var language = browserCookies[LANGUAGE_COOKIE_KEY] || LANGUAGES.ES;
var country = ((_browserCookies$COUNT = browserCookies[COUNTRY_COOKIE_KEY]) === null || _browserCookies$COUNT === void 0 ? void 0 : /*#__PURE__*/_browserCookies$COUNT.toLocaleLowerCase()) || '*';
export var cookieValues = {
  country: country,
  language: language
};